import axios from "axios";

import { baseUrl } from "./baseUrl";

// Home page organizer api
const api = axios.create({
    baseURL: `${baseUrl}/admin/homepage-organizer`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const getRewardsPageText = async (screenName) => {
    try {
        const response = await api.get(`/rewards-section?screenName=${screenName}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching rewards page text:", error);
        throw error;
    }
}

export const updateRewardsPageText = async (data) => {
    try {
        const response = await api.put("/rewards-section", data);
        return response.data;
    } catch (error) {
        console.error("Error updating rewards page text:", error);
        throw error;
    }
}